import { List, Stack, Text } from '@mantine/core';
import { UnderlineTooltip } from 'src/UI/common';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { LeftOutNames, REASON_LABELS, REASON_ORDER, ReasonLabels } from '../leftOut';

export function LeftOutNote({
  names,
  labels = REASON_LABELS,
}: {
  names: LeftOutNames;
  labels?: ReasonLabels;
}) {
  const reasons = REASON_ORDER.filter(reason => names[reason].length > 0);
  const count = reasons.reduce((total, reason) => total + names[reason].length, 0);
  if (count === 0) return null;

  return (
    <UnderlineTooltip
      size="xs"
      fw={FONT_WEIGHTS.semibold}
      c="gray.6"
      multiline
      position="bottom-end"
      focusable
      label={
        <Stack gap="xs" data-testid="left-out-list">
          <Text size="xs" fw={FONT_WEIGHTS.bold}>
            Not included in this total
          </Text>
          {reasons.map(reason => (
            <Stack key={reason} gap={2}>
              <Text size="xs" fw={FONT_WEIGHTS.semibold}>
                {labels[reason]}
              </Text>
              <List size="xs" spacing={2}>
                {names[reason].map((name, index) => (
                  <List.Item key={`${name}-${index}`}>{name}</List.Item>
                ))}
              </List>
            </Stack>
          ))}
          <Text size="xs">Edit an item to add what&apos;s missing.</Text>
        </Stack>
      }
    >
      {count === 1 ? '1 item not included' : `${count} items not included`}
    </UnderlineTooltip>
  );
}
